// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-pane-host,
.social-pane {
  --profile-interactive-cursor: pointer;
  display: block;
  background: var(--color-background, #F8F9FB);
  border-radius: var(--border-radius-base, 0.3125rem);
  overflow: visible;
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  max-width: none;
  margin: 0;
}

.social-pane__header-content {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: flex-start;
  column-gap: var(--spacing-md, 1.25rem);
  row-gap: var(--spacing-xxs, 0.3125rem);
  min-width: 0;
  width: 100%;
}

.social-pane__header-media {
  grid-column: 1;
  grid-row: 1;
}

.social-pane__header-details {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.social-pane__header-actions {
  grid-column: 3;
  grid-row: 1;
  margin-left: auto;
  align-self: flex-start;
  justify-self: end;
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-xs, 0.5rem);
  flex-wrap: wrap;
}

.social-pane__header-actions--friend {
  justify-content: center;
}

.social-pane__header-actions--friend > solid-ui-button {
  margin-inline: auto;
  --button-border-radius: var(--border-radius-md, 0.5rem);
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-hover-border: var(--color-primary, #7C4DFF);
}

.social-pane__header-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xxs, 0.125rem);
  width: 100%;
  max-width: 100%;
}

.social-pane__header-stats {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs, 0.75rem);
  justify-content: flex-start;
  align-self: flex-start;
  margin-top: var(--spacing-xxs, 0.3125rem);
}

.social-pane__header-stat {
  appearance: none;
  border: 0;
  background: transparent;
  cursor: var(--profile-interactive-cursor, pointer);
  color: var(--slate-700, #314158);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-bold, 600);
  line-height: var(--line-height-tight, 1.4);
  padding: 0;
  text-decoration: none;
}

.social-pane__header-stat + .social-pane__header-stat::before {
  content: '◆';
  color: var(--gray-400, #99A1AF);
  font-size: 0.5rem;
  margin-right: var(--spacing-xs, 0.75rem);
  vertical-align: middle;
}

.social-pane__header-stat:hover .social-pane__header-stat-label {
  text-decoration: underline;
}

.social-pane__header-stat:focus-visible {
  outline: var(--border-width-medium, 2px) solid #111827;
  outline-offset: 2px;
}

.social-pane__edit-button {
  position: static;
  display: inline-block;
  min-width: 0;
  width: auto;
  max-width: none;
  --button-height-sm: 0;
  --button-padding-sm: var(--spacing-xxs, 0.3125rem);
  --button-background: transparent;
  --button-border: transparent;
  --button-border-width: 0;
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-font-weight: var(--font-weight-regular, 400);
  --button-line-height: var(--line-height-base, 1.5);
  --button-icon-size-sm: 0.875rem;
}

.social-pane__edit-button::part(button):hover {
  text-decoration: underline;
}

.social-pane__edit-button::part(button):focus-visible {
  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
}

.social-pane__edit-button-label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xxs, 0.3125rem);
}

.social-pane__edit-button .profile-section-collapsible__edit-icon,
.social-pane__edit-button-icon {
  display: none;
  line-height: 0;
}

.social-pane__edit-button-label svg,
.social-pane__edit-button-icon svg,
.social-pane__edit-button .profile-section-collapsible__edit-icon svg {
  width: 0.875rem;
  height: 0.875rem;
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: middle;
}

.social-pane__edit-button-label svg path,
.social-pane__edit-button-icon svg path,
.social-pane__edit-button .profile-section-collapsible__edit-icon svg path {
  fill: var(--color-primary, #7C4DFF);
  stroke: none;
}

.social-pane__dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  padding: 1rem;
  background: rgb(15 23 42 / 0.45);
}

.social-pane__dialog {
  position: relative;
  width: min(32rem, 100%);
  max-height: calc(100vh - 2rem);
  overflow: auto;
  border-radius: 1rem;
  background: var(--white, #fff);
  color: var(--color-text, #111827);
  padding: var(--spacing-md, 1.25rem);
  box-shadow: 0 20px 45px rgb(15 23 42 / 0.25);
}

.social-pane__dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-md, 1rem);
  padding-bottom: var(--spacing-base, 0.5rem);
  margin-bottom: var(--spacing-sm, 0.938rem);
  border-bottom: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);
}

.social-pane__dialog-title {
  margin: 0 0 var(--spacing-base, 0.5rem);
}

.social-pane__dialog-close {
  flex: 0 0 auto;
  --button-background: transparent;
  --button-border: transparent;
  --button-border-width: 0;
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  color: var(--color-text-subheading, #6b7280);
  cursor: pointer;
  padding: 0;
  line-height: 0;
}

.social-pane__dialog-close:hover {
  color: var(--color-text-primary, #364153);
}

.social-pane__dialog-close:focus-visible {
  outline: var(--border-width-medium, 2px) solid var(--color-text-primary, #364153);
  outline-offset: 2px;
}

.social-pane__dialog-close svg {
  width: var(--icon-xxxs, 0.75rem);
  height: var(--icon-xxxs, 0.75rem);
}

.social-pane__dialog-close svg path {
  fill: currentColor;
}

.social-pane__dialog-form {
  gap: var(--spacing-sm, 0.938rem);
}

.social-pane__dialog-fields {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 0.938rem);
}

.social-pane__dialog-field {
  gap: 0.2rem;
}

.social-pane__dialog-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-xs, 0.75rem);
}

.social-pane__dialog-row-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.social-pane__dialog-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.45rem;
}

.social-pane__dialog-label {
  margin: 0;
  color: var(--gray-700, #364153);
  font-size: var(--font-size-md, 1rem); /* 16px */
  font-weight: var(--font-weight-md, 500);
  line-height: normal;
}

.social-pane__dialog-input {
  width: 100%;
  box-sizing: border-box;
  min-height: auto;
  resize: none;
}

.social-pane__dialog-error {
  min-height: 1.25rem;
  margin: 0;
  color: var(--color-warning, red);
}

.social-pane__dialog-saving-overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.78);
  z-index: 10;
}

.social-pane__dialog-saving-overlay[hidden] {
  display: none;
}

.social-pane__dialog.modal--saving .social-pane__dialog-form {
  opacity: 0.45;
  pointer-events: none;
}

.social-pane__dialog .modal__saving-indicator {
  gap: 0;
}

.social-pane__dialog-row-button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  flex: 0 0 auto;
}

.social-pane__dialog-row-button-icon svg {
  display: block;
}

.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add {
  justify-self: flex-start;
  width: auto;
  min-width: 0;
  max-width: none;
  margin-left: auto;
  flex: 0 0 auto;
  box-sizing: border-box;
  --button-min-height: auto;
  --button-padding-sm: var(--spacing-xxs, 0.3125rem);
  --button-background: transparent;
  --button-border: transparent;
  --button-border-width: 0;
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-height-sm: auto;
  --button-font-weight: var(--font-weight-md, 500);
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-line-height: var(--line-height-base, 1.5);
}

.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {
  min-height: auto;
  padding: var(--spacing-xxs, 0.3125rem);
  border: none;
  background: none;
  color: var(--color-primary, #7C4DFF);
  font-weight: var(--font-weight-md, 500);
}

.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add:hover::part(button) {
  text-decoration: underline;
}

.social-pane__add-more-content {
  display: inline;
}

.social-pane__add-more-inline {
  display: inline;
  white-space: normal;
}

.social-pane__add-more-icon {
  display: inline-block;
  width: var(--icon-xxxs, 0.75rem);
  height: var(--icon-xxxs, 0.75rem);
  margin-right: var(--spacing-xxs, 0.3125rem);
  line-height: 0;
  vertical-align: text-top;
}

.social-pane__add-more-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove {
  min-height: var(--min-touch-target, 44px);
  min-width: var(--min-touch-target, 44px);
  color: var(--gray-300, #D1D5DC);
  --button-background: transparent;
  --button-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  --button-border: transparent;
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-base, 0.3125rem);
  --button-hover-background: var(--lavender-300, #e6dcff);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-hover-box-shadow: none;
  --button-text: currentColor;
  --button-height-md: var(--min-touch-target, 44px);
  --button-padding-md: 0;
  --button-padding-x-sm: 0;
  --button-icon-size-md: var(--icon-xxs, 1rem);
  --button-icon-size-lg: var(--icon-xxs, 1rem);
}

.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove:hover,
.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove:focus-within {
  color: var(--gray-300, #D1D5DC);
}

.social-pane__dialog-row-button-icon--remove svg {
  width: 1rem;
  height: 1rem;
}

.social-pane__dialog-row-button-icon--remove svg path {
  stroke: currentColor;
}

.social-pane__dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-xs, 0.75rem);
  padding-top: var(--spacing-base, 0.5rem);
  margin-top: 0;
  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);
}

.social-pane__dialog-actions > solid-ui-button {
  width: 10.8rem;
}

.social-pane__dialog-actions > solid-ui-button {
  --button-border-width: 1px;
  --button-border-radius: var(--border-radius-base, 0.3125rem);
  --button-box-shadow: none;
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
}

.social-pane__dialog-actions solid-ui-button.social-pane__dialog-button--save {
  --button-font-size-md: var(--font-size-lg, 1.125rem);
  --button-background: var(--color-primary, #7C4DFF);
  --button-border: var(--color-primary, #7C4DFF);
  --button-text: var(--white, #FFF);
  --button-hover-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 90%, black);
  --button-hover-border: color-mix(in srgb, var(--color-primary, #7C4DFF) 90%, black);
  --button-hover-text: var(--white, #FFF);
}

.social-pane__dialog-actions solid-ui-button.social-pane__dialog-button--cancel {
  --button-background: var(--white, #FFF);
  --button-border: var(--gray-300, #D1D5DC);
  --button-font-weight: var(--font-weight-normal, normal);
  --button-text: var(--gray-800, #1E2939);
  --button-hover-background: var(--blue-900, #083575);
  --button-hover-border: var(--blue-900, #083575);
  --button-hover-text: var(--white, #FFF);
  --button-font-size-md: var(--font-size-sm, 0.875rem);
}

.social-pane__header-name {
  color: var(--color-text-heading, #000);
  font-size: var(--font-size-xxl, 1.75rem); /* 28px */
  font-weight: var(--font-weight-bold, 600);
  margin: 0;
  padding: 0;
  text-indent: 0;
  line-height: 1.2;
  text-align: left;
  overflow-wrap: anywhere;
  transform: translateX(-4px);
}

.social-pane__header-location {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2xs, 0.625rem);
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-normal, 400);
  line-height: 1.2;
}

.social-pane__header-job-org {
  margin: 0;
  color: var(--color-text-subheading, #101828);
  width: 100%;
  white-space: normal;
  font-size: var(--font-size-lg, 1.125rem);
  font-weight: var(--font-weight-md, 500);
  line-height: 1.25;
  text-align: left;
}

.social-pane__header-location-icon {
  line-height: 0;
}

.social-pane__header-location-icon svg {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
}

.social-profile-links {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  align-items: start;
  column-gap: 1rem;
  row-gap: 0.15rem;
}

.social-pane__header-hero {
  width: 140px;
  height: 140px;
  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);
  background: var(--gray-200, #E5E7EB) 50% / cover no-repeat;
  background-position: 50%;
  object-fit: cover;
  object-position: center;
}

.social-pane__header-hero-icon {
  width: 140px;
  height: 140px;
  border-radius: var(--border-radius-full, 0.625rem) !important;
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);
  background: var(--color-card-bg);
  line-height: 0;
  flex-shrink: 0;
}

.social-pane__header-hero-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}


.social-pane .social-layout {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
}

.social-pane .social-primary {
  flex: 1 1 70%;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, auto);
  gap: 0;
  align-items: start;
}

.social-pane .social-primary__tabs {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  gap: var(--spacing-base, 0.5rem);
  padding: 0;
  background: transparent;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.social-pane .social-primary__tab {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;
  border-radius: 0;
  background: transparent;
  color: #374151;
  cursor: pointer;
  font: inherit;
  font-weight: var(--font-weight-bold, 600);
  padding: var(--spacing-2xs, 0.625rem) 1rem;
  box-shadow: none !important;
  transition: background-color 120ms ease, color 120ms ease, box-shadow 120ms ease;
}

.social-pane .social-primary__tab:hover {
  background: var(--lavender-300, #e6dcff) !important;
  color: var(--grey-purple-900, #332746);
  box-shadow: none !important;
}

.social-pane .social-primary__tab[aria-selected='true'],
.social-pane .social-primary__tab--active {
  background: transparent;
  color: var(--grey-purple-900, #332746);
  box-shadow: none !important;
  border-bottom-color: var(--color-primary, #7C4DFF);
}

.social-pane .social-primary__tab:focus-visible {
  outline: none;
  outline-offset: 2px;
  box-shadow: none !important;
}

.social-pane .social-primary__panel {
  grid-column: 1;
  grid-row: 2;
  display: none;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(0.35rem);
  transition: opacity 160ms ease, transform 160ms ease, visibility 0s linear 160ms;
}

.social-pane .social-primary__panel--active {
  display: block;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
  border: 0;
  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;
  transition: opacity 180ms ease, transform 180ms ease;
}

.social-pane .social-pane__mutual-friends,
.social-pane .social-pane__all-friends {
  margin-top: 0;
  padding-top: var(--spacing-xxxs, 0.2rem);
}

.social-pane .social-main {
  display: table;
  background-color: var(--color-card-bg, #fff);
  color: var(--color-text-primary, #364153);
  border: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  border-collapse: collapse;
}

.social-pane .social-main--mutual {
  gap: var(--spacing-xs, 0.75rem);
  margin-top: 1em;
  margin-bottom: 1em;
  padding: 1rem;
  border-radius: var(--border-radius-lg, 0.75rem);
}

.social-pane .social-main--requests {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md, 1rem);
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: var(--border-radius-lg, 0.75rem);
}

.social-requests__note {
  margin: 0;
  color: var(--color-text-subheading, #475467);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.5;
}

.social-requests__group {
  gap: var(--spacing-sm, 0.938rem);
}

.social-requests__group-header {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.social-requests__group-title {
  margin: 0;
  color: var(--color-text-heading, #101828);
  font-size: var(--font-size-lg, 1.125rem);
  line-height: 1.25;
}

.social-requests__group-description,
.social-requests__empty {
  margin: 0;
  color: var(--color-text-subheading, #667085);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.5;
}

.social-requests__table {
  margin-top: 0;
}

.social-pane .social-mutual-summary {
  gap: var(--spacing-base, 0.5rem);
}

.social-pane .social-mutual-summary-line {
  color: var(--slate-700, #314158);
  font-size: var(--font-size-sm, 0.95rem);
  line-height: var(--line-height-base, 1.5);
  justify-content: flex-start;
  padding: 1rem;
}

.social-pane .social-mutual-summary-line--action {
  flex-wrap: wrap;
  gap: var(--spacing-xxs, 0.75rem);
}

.social-pane .social-mutual-confirm-prompt {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-xxxs, 0.2rem);
  font-weight: var(--font-weight-semibold, 600);
}

.social-pane .social-pane__friend-action--inline {
  position: static;
  top: auto;
  right: auto;
  z-index: auto;
  align-self: flex-start;
}

.social-pane .social-mutual-checkbox-form {
  display: block;
  margin: 0;
  padding: 0 1rem 1rem;
}

.social-pane .social-mutual-checkbox-form label {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-2xs, 0.65rem);
  color: var(--slate-700, #374151);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.4;
}

.social-pane .social-mutual-checkbox-form input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  margin: 0;
  accent-color: var(--color-primary, #7C4DFF);
}

.social-pane .social-mutual-checkbox-form input[type='checkbox']:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.social-pane .social-friends-list {
  width: 100%;
  margin-top: 0;
}

.social-pane .social-friends-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  gap: var(--spacing-xs, 0.75rem);
}

.social-pane .social-friends-grid > tbody {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  gap: var(--spacing-xs, 0.75rem);
}

.social-pane .social-friends-grid > tr,
.social-pane .social-friends-grid > tbody > tr {
  display: inline-table;
  width: calc(50% - 0.375rem);
  table-layout: fixed;
  box-sizing: border-box;
}

.social-pane .social-friends-grid > tr,
.social-pane .social-friends-grid > tbody > tr,
.social-pane .social-friend-card {
  border: 1px solid var(--gray-200, #E5E7EB);
  background: var(--white, #fff);
  border-radius: var(--border-radius-lg, 0.75rem);
  overflow: visible;
  box-shadow: 0 1px 3px rgb(0 0 0 / 0.08);
  transition: box-shadow 140ms ease, border-color 140ms ease, transform 140ms ease;
}

.social-pane .social-friends-grid > tr:hover,
.social-pane .social-friends-grid > tbody > tr:hover,
.social-pane .social-friend-card:hover {
  border-color: var(--gray-300, #D1D5DC);
  box-shadow: 0 6px 18px rgb(0 0 0 / 0.1);
  transform: translateY(-1px);
}

.social-pane .social-friends-grid > tr td,
.social-pane .social-friends-grid > tbody > tr td,
.social-pane .social-friend-card td {
  background: var(--color-background, #F8F9FB);
  box-sizing: border-box;
}

.social-pane .social-friends-grid > tr > td:nth-child(2),
.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) {
  width: auto;
  min-width: 0;
  padding-left: 1.4rem;
}

.social-pane .social-friends-grid > tr > td:nth-child(3),
.social-pane .social-friends-grid > tbody > tr > td:nth-child(3) {
  width: 2.5rem;
  min-width: 2.5rem;
  padding-left: 0.25rem;
  vertical-align: top;
}

.social-pane .social-friends-grid > tr > td:first-child,
.social-pane .social-friends-grid > tbody > tr > td:first-child {
  padding-right: 1.2rem;
}

.social-pane .social-friends-grid td > div > div {
  min-width: 0 !important;
  max-width: 100% !important;
  width: 100% !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
}

.social-pane .social-friends-grid td > div > div button {
  white-space: normal !important;
}

.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child,
.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) > div:first-child {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.2rem 0.4rem;
  min-width: 0;
}

/* change the style of the name / label in the friend card */
.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child > span:first-of-type,
.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) > div:first-child > span:first-of-type {
  display: inline-block;
  max-width: 100%;
  vertical-align: text-top;
  font-size: var(--font-size-lg, 1.125rem); /* 18px */
  font-weight: var(--font-weight-bold, 600); /* new design uses 600 */
  line-height: var(--line-height-tight);
  margin-top: 0;
  margin-bottom: 0;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}

.social-pane .social-friend-pronouns {
  display: inline;
  margin-left: var(--spacing-xs, 0.25rem);
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.2;
  text-align: left;
}

.social-pane .social-friend-job-org {
  margin: 0;
  width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  color: var(--color-text-subheading, #101828);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  line-height: 1.25;
  text-align: left;
}

.social-pane .social-friend-location {
  color: var(--color-text-secondary, #6b7280);
  font-size: var(--font-size-xs, 0.8125rem);
  line-height: 1.3;
  overflow-wrap: anywhere;
}

@media (max-width: 960px) {
  .social-pane .social-friends-grid > tr,
  .social-pane .social-friends-grid > tbody > tr {
    width: 100%;
  }
}

.social-pane .social-friends-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-xs, 0.75rem) var(--spacing-base, 0.5rem);
  background-color: var(--gray-100, #F3F4F6);
  caption-side: top;
  margin-top: 0;
}

.social-pane .social-friends-header-title {
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--font-weight-bold, 600);
  color: var(--color-text-primary, #364153);
}

.social-pane .social-friends-header-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.social-pane .social-friends-header-actions--standalone {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs, 0.75rem);
  justify-content: flex-start;
  padding: 0.7rem 1rem 0;
}

.social-pane .social-friends-header-dropzone {
  border-collapse: collapse;
}

.social-pane .social-friends-header-dropzone-cell {
  padding: 0;
}

.social-pane .social-friends-header-hint {
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.4;
}

.social-pane .social-friends-header-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem !important;
  min-width: 2rem !important;
  height: 2rem !important;
  padding: 0 !important;
  margin: 0 !important;
  border-width: 0 !important;
  overflow: hidden;
}

.social-pane .social-friends-header-actions button img {
  display: block;
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
  pointer-events: none;
}

/* From tabbedtab.css */
/* ***************** Social Pane **********/

div.social-pane {
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.social-pane a {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
  font-weight: bold;
}
.social-pane a:hover {
  color: var(--color-primary, #7C4DFF);
  text-decoration: underline;
  font-weight: bold;
}
.social-pane a:active {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
}

.social-pane__link-button {
  width: fit-content;
  max-width: 100%;
  display: inline-flex;
  white-space: nowrap;
  background-color: transparent;
  border: none;
  margin-top: 0;
  margin-bottom: 0;
  padding: var(--spacing-xxxs, 0.2rem) var(--spacing-base, 0.5rem);
  text-align: left;
}

.social-pane__link-button > a {
  display: inline-flex;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  background-color: transparent;
  color: var(--color-primary, #7C4DFF);
}

.social-pane__link-button > a:link,
.social-pane__link-button > a:visited,
.social-pane__link-button > a:hover {
  color: var(--color-primary, #7C4DFF);
}

.social-pane__link-button > a:hover {
  text-decoration: underline;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-content {
  display: grid;
  grid-template-columns: 4.375rem minmax(0, 1fr) auto;
  align-items: start;
  column-gap: var(--spacing-md, 1rem);
  row-gap: 0.25rem;
  padding: 1rem 1rem 0;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-media {
  display: contents;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-details {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  min-width: 0;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-actions {
  grid-column: 3;
  grid-row: 1;
  justify-self: end;
  justify-content: flex-end;
  width: auto;
  gap: var(--spacing-2xs, 0.3125rem);
  margin-left: 0;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-actions--friend {
  grid-column: 1 / -1;
  grid-row: 3;
  justify-self: stretch;
  justify-content: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0.125rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-summary {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-name, .social-pane__header-job-org, .social-pane__header-location) {
  width: 100%;
  text-align: left;
  justify-content: flex-start;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-stats {
  width: 100%;
  justify-content: flex-start;
  align-self: flex-start;
  gap: var(--spacing-xs, 0.5rem);
  margin-top: -0.4375rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-profile-links {
  grid-column: 1 / -1;
  grid-row: 2;
  grid-template-columns: 1fr;
  row-gap: var(--spacing-xxxs, 0.2rem);
  justify-items: start;
  padding-left: 0;
  margin-top: -0.375rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-primary__tabs,
:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-primary__tabs {
  margin-top: -0.5rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__link-button {
  justify-self: start;
  padding-left: 0;
  padding-right: 0;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__link-button > a {
  font-size: var(--font-size-sm, 0.875rem);
  text-align: left;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-field-header {
  grid-template-columns: minmax(0, 1fr);
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-hero, .social-pane__header-hero-icon) {
  grid-column: 1;
  grid-row: 1;
  width: 5rem;
  height: 5rem;
  aspect-ratio: 1 / 1;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-name {
  font-size: var(--font-size-xl, 1.375rem);
  line-height: 1.15;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-job-org {
  font-size: var(--font-size-md, 1rem);
  line-height: 1.25;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friend-pronouns {
  font-size: 0.6875rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-location, .social-pane__header-stat),
:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friend-location {
  font-size: var(--font-size-xxs, 0.75rem);
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-label, .social-pane__edit-button .profile-section-collapsible__edit-label) {
  display: none !important;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__edit-button {
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-text: var(--color-text, #1A1A1A);
  --button-hover-background: var(--lavender-300, #e6dcff);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-text, #1A1A1A);
  --button-font-size-sm: clamp(0.9rem, 2.1vw, 1rem);
  --button-font-weight: var(--font-weight-regular, 400);
  --button-icon-size-sm: 0.875rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon, .social-pane__edit-button .profile-section-collapsible__edit-icon) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.875rem;
  height: 0.875rem;
  line-height: 0;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon svg, .social-pane__edit-button .profile-section-collapsible__edit-icon svg) {
  width: 0.875rem;
  height: 0.875rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon svg path, .social-pane__edit-button .profile-section-collapsible__edit-icon svg path) {
  fill: var(--color-text, #1A1A1A);
  stroke: none;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-actions {
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm, 0.938rem);
  padding: var(--spacing-md, 1rem) 0 0;
  margin: var(--spacing-md, 1rem) auto 0;
  box-sizing: border-box;
  width: 100%;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-actions > solid-ui-button {
  flex: 0 0 auto;
  width: 10.8rem;
  min-width: 8.5rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {
  font-size: var(--font-size-sm, 0.875rem);
  line-height: var(--line-height-base, 1.5);
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friends-header-actions--standalone {
  flex-wrap: wrap;
  gap: var(--spacing-2xs, 0.625rem);
  padding-top: 0.35rem;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane .social-layout, .social-pane .social-primary, .social-layout, .social-primary) {
  display: block;
}

:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friends-grid,
:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-friends-grid {
  display: block;
}

:is(.social-pane-host, .social-pane)[data-input-mode='touch'] {
  --profile-interactive-cursor: auto;
}

:is(.social-pane-host, .social-pane)[data-input-mode='pointer'] {
  --profile-interactive-cursor: pointer;
}

@media (max-width: 600px) {
  .social-pane__header-content {
    display: grid;
    grid-template-columns: 4.375rem minmax(0, 1fr) auto;
    align-items: start;
    column-gap: var(--spacing-md, 1rem);
    row-gap: 0.25rem;
    padding: 1rem 1rem 0;
  }

  .social-pane__header-media {
    display: contents;
  }

  .social-pane__header-details {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.125rem;
    min-width: 0;
  }

  .social-pane__header-actions {
    grid-column: 3;
    grid-row: 1;
    justify-self: end;
    justify-content: flex-end;
    width: auto;
    gap: var(--spacing-2xs, 0.3125rem);
    margin-left: 0;
  }

  .social-pane__header-actions--friend {
    grid-column: 1 / -1;
    grid-row: 3;
    justify-self: stretch;
    justify-content: center;
    width: 100%;
    margin-left: 0;
    margin-top: 0.125rem;
  }

  .social-pane__header-summary {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
  }

  .social-pane__header-name,
  .social-pane__header-job-org,
  .social-pane__header-location {
    width: 100%;
    text-align: left;
    justify-content: flex-start;
  }

  .social-pane__header-stats {
    width: 100%;
    justify-content: flex-start;
    align-self: flex-start;
    gap: var(--spacing-xs, 0.5rem);
    margin-top: -0.4375rem;
  }

  .social-profile-links {
    grid-column: 1 / -1;
    grid-row: 2;
    grid-template-columns: 1fr;
    row-gap: var(--spacing-xxxs, 0.2rem);
    justify-items: start;
    padding-left: 0;
    margin-top: -0.375rem;
  }

  .social-pane .social-primary__tabs {
    margin-top: -0.5rem;
  }

  .social-pane__link-button {
    justify-self: start;
    padding-left: 0;
    padding-right: 0;
  }

  .social-pane__link-button > a {
    font-size: var(--font-size-sm, 0.875rem);
    text-align: left;
  }

  .social-pane__dialog-field-header {
    grid-template-columns: minmax(0, 1fr);
  }

  .social-pane__header-hero,
  .social-pane__header-hero-icon {
    grid-column: 1;
    grid-row: 1;
    width: 5rem;
    height: 5rem;
    aspect-ratio: 1 / 1;
  }

  .social-pane__header-name {
    font-size: var(--font-size-xl, 1.375rem);
    line-height: 1.15;
  }

  .social-pane__header-job-org {
    font-size: var(--font-size-md, 1rem);
    line-height: 1.25;
  }

  .social-pane .social-friend-pronouns {
    font-size: 0.6875rem;
  }

  .social-pane__header-location,
  .social-pane__header-stat,
  .social-pane .social-friend-location {
    font-size: var(--font-size-xxs, 0.75rem);
  }

  .social-pane__friend-action {
    --button-padding-sm: var(--spacing-xxxs, 0.2rem) var(--spacing-xxs-old, 0.3rem);
    --button-font-size-sm: var(--font-size-xs, 0.813rem);
    --button-border-radius-sm: var(--border-radius-base, 0.3125rem);
  }

  .social-pane__edit-button-label,
  .social-pane__edit-button .profile-section-collapsible__edit-label {
    display: none !important;
  }

  .social-pane__edit-button {
    --button-background: transparent;
    --button-border-width: 0;
    --button-border: transparent;
    --button-background: transparent;
    --button-text: var(--color-text, #1A1A1A);
    --button-hover-background: var(--lavender-300, #e6dcff);
    --button-hover-border: transparent;
    --button-hover-text: var(--color-text, #1A1A1A);
    --button-font-size-sm: clamp(0.9rem, 2.1vw, 1rem);
    --button-font-weight: var(--font-weight-regular, 400);
    --button-icon-size-sm: 0.875rem;
  }

  .social-pane__edit-button-icon,
  .social-pane__edit-button .profile-section-collapsible__edit-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 0.875rem;
    height: 0.875rem;
    line-height: 0;
  }

  .social-pane__edit-button-icon svg,
  .social-pane__edit-button .profile-section-collapsible__edit-icon svg {
    width: 0.875rem;
    height: 0.875rem;
  }

  .social-pane__edit-button-icon svg path,
  .social-pane__edit-button .profile-section-collapsible__edit-icon svg path {
    fill: var(--color-text, #1A1A1A);
    stroke: none;
  }

  .social-pane__dialog-actions {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm, 0.938rem);
    padding: var(--spacing-md, 1rem) 0 0;
    margin: var(--spacing-md, 1rem) auto 0;
    box-sizing: border-box;
    width: 100%;
  }

  .social-pane__dialog-actions > solid-ui-button {
    flex: 0 0 auto;
    width: 10.8rem;
    min-width: 8.5rem;
  }

  .social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {
    font-size: var(--font-size-sm, 0.875rem);
    line-height: var(--line-height-base, 1.5);
  }

  .social-pane .social-friends-header-actions--standalone {
    flex-wrap: wrap;
    gap: var(--spacing-2xs, 0.625rem);
    padding-top: 0.35rem;
  }

  .social-pane .social-layout,
  .social-pane .social-primary {
    display: block;
  }

  .social-pane .social-friends-grid {
    display: block;
  }

  .social-pane .social-friends-grid > tr,
  .social-pane .social-friends-grid > tbody > tr {
    display: table;
    width: 100%;
    margin-bottom: var(--spacing-xs, 0.75rem);
  }

  .social-pane .social-friends-grid > tr:last-child,
  .social-pane .social-friends-grid > tbody > tr:last-child {
    margin-bottom: 0;
  }

  .social-pane .social-main {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/social/socialPane.css"],"names":[],"mappings":"AAAA;;EAEE,qCAAqC;EACrC,cAAc;EACd,4CAA4C;EAC5C,mDAAmD;EACnD,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,uBAAuB;EACvB,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uDAAuD;EACvD,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kDAAkD;EAClD,gCAAgC;EAChC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kDAAkD;EAClD,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,4CAA4C;EAC5C,kDAAkD;EAClD,oDAAoD;EACpD,qDAAqD;EACrD,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,2CAA2C;EAC3C,0CAA0C;EAC1C,6EAA6E;AAC/E;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,4CAA4C;EAC5C,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC,EAAE,SAAS;EAC/C,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kDAAkD;EAClD,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,4CAA4C;EAC5C,kDAAkD;EAClD,wBAAwB;EACxB,gDAAgD;EAChD,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,4DAA4D;EAC5D,uDAAuD;EACvD,kCAAkC;EAClC,kDAAkD;EAClD,+BAA+B;EAC/B,2BAA2B;EAC3B,iDAAiD;EACjD,sBAAsB;EACtB,wBAAwB;EACxB,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,wCAAwC;EACxC,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4DAA4D;EAC5D,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,oDAAoD;EACpD,kDAAkD;EAClD,8CAA8C;EAC9C,iCAAiC;EACjC,uFAAuF;EACvF,mFAAmF;EACnF,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,uDAAuD;EACvD,uCAAuC;EACvC,mDAAmD;EACnD,+CAA+C;EAC/C,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;EACtC,wCAAwC,EAAE,SAAS;EACnD,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kDAAkD,EAAE,SAAS;EAC7D,0EAA0E;EAC1E,0DAA0D;EAC1D,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,0EAA0E;EAC1E,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,wCAAwC;EACxC,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,+DAA+D;EAC/D,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,mDAAmD;EACnD,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,SAAS;EACT,+DAA+D;EAC/D,oDAAoD;AACtD;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,4CAA4C;EAC5C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,0CAA0C;EAC1C,8BAA8B;EAC9B,+CAA+C;EAC/C,iBAAiB;EACjB,uCAAuC;EACvC,gFAAgF;AAClF;;AAEA;;;EAGE,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;;;EAGE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA,4DAA4D;AAC5D;;EAEE,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,wCAAwC,EAAE,SAAS;EACnD,yCAAyC,EAAE,wBAAwB;EACnE,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,2CAA2C;EAC3C,wCAAwC,EAAE,SAAS;EACnD,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,wCAAwC;EACxC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iEAAiE;EACjE,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB,2CAA2C;;AAE3C;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,yCAAyC;EACzC,uDAAuD;EACvD,kCAAkC;EAClC,+CAA+C;EAC/C,iDAAiD;EACjD,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,aAAa;IACb,mDAAmD;IACnD,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;EACb;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,wCAAwC;EAC1C;;EAEA;IACE,+EAA+E;IAC/E,oDAAoD;IACpD,+DAA+D;EACjE;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,4BAA4B;IAC5B,gCAAgC;IAChC,yCAAyC;IACzC,uDAAuD;IACvD,kCAAkC;IAClC,+CAA+C;IAC/C,iDAAiD;IACjD,qDAAqD;IACrD,+BAA+B;EACjC;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,gCAAgC;IAChC,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,oCAAoC;IACpC,sCAAsC;IACtC,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,yCAAyC;EAC3C;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".social-pane-host,\r\n.social-pane {\r\n  --profile-interactive-cursor: pointer;\r\n  display: block;\r\n  background: var(--color-background, #F8F9FB);\r\n  border-radius: var(--border-radius-base, 0.3125rem);\r\n  overflow: visible;\r\n  width: 100%;\r\n  min-width: 100%;\r\n  box-sizing: border-box;\r\n  max-width: none;\r\n  margin: 0;\r\n}\r\n\r\n.social-pane__header-content {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: flex-start;\r\n  column-gap: var(--spacing-md, 1.25rem);\r\n  row-gap: var(--spacing-xxs, 0.3125rem);\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n.social-pane__header-media {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n\r\n.social-pane__header-details {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  min-width: 0;\r\n}\r\n\r\n.social-pane__header-actions {\r\n  grid-column: 3;\r\n  grid-row: 1;\r\n  margin-left: auto;\r\n  align-self: flex-start;\r\n  justify-self: end;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--spacing-xs, 0.5rem);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.social-pane__header-actions--friend {\r\n  justify-content: center;\r\n}\r\n\r\n.social-pane__header-actions--friend > solid-ui-button {\r\n  margin-inline: auto;\r\n  --button-border-radius: var(--border-radius-md, 0.5rem);\r\n  --button-hover-text: var(--color-primary, #7C4DFF);\r\n  --button-hover-border: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane__header-summary {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: var(--spacing-xxs, 0.125rem);\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.social-pane__header-stats {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  justify-content: flex-start;\r\n  align-self: flex-start;\r\n  margin-top: var(--spacing-xxs, 0.3125rem);\r\n}\r\n\r\n.social-pane__header-stat {\r\n  appearance: none;\r\n  border: 0;\r\n  background: transparent;\r\n  cursor: var(--profile-interactive-cursor, pointer);\r\n  color: var(--slate-700, #314158);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  font-weight: var(--font-weight-bold, 600);\r\n  line-height: var(--line-height-tight, 1.4);\r\n  padding: 0;\r\n  text-decoration: none;\r\n}\r\n\r\n.social-pane__header-stat + .social-pane__header-stat::before {\r\n  content: '◆';\r\n  color: var(--gray-400, #99A1AF);\r\n  font-size: 0.5rem;\r\n  margin-right: var(--spacing-xs, 0.75rem);\r\n  vertical-align: middle;\r\n}\r\n\r\n.social-pane__header-stat:hover .social-pane__header-stat-label {\r\n  text-decoration: underline;\r\n}\r\n\r\n.social-pane__header-stat:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid #111827;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__edit-button {\r\n  position: static;\r\n  display: inline-block;\r\n  min-width: 0;\r\n  width: auto;\r\n  max-width: none;\r\n  --button-height-sm: 0;\r\n  --button-padding-sm: var(--spacing-xxs, 0.3125rem);\r\n  --button-background: transparent;\r\n  --button-border: transparent;\r\n  --button-border-width: 0;\r\n  --button-hover-background: transparent;\r\n  --button-hover-border: transparent;\r\n  --button-text: var(--color-primary, #7C4DFF);\r\n  --button-hover-text: var(--color-primary, #7C4DFF);\r\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\r\n  --button-font-weight: var(--font-weight-regular, 400);\r\n  --button-line-height: var(--line-height-base, 1.5);\r\n  --button-icon-size-sm: 0.875rem;\r\n}\r\n\r\n.social-pane__edit-button::part(button):hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.social-pane__edit-button::part(button):focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__edit-button-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--spacing-xxs, 0.3125rem);\r\n}\r\n\r\n.social-pane__edit-button .profile-section-collapsible__edit-icon,\r\n.social-pane__edit-button-icon {\r\n  display: none;\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__edit-button-label svg,\r\n.social-pane__edit-button-icon svg,\r\n.social-pane__edit-button .profile-section-collapsible__edit-icon svg {\r\n  width: 0.875rem;\r\n  height: 0.875rem;\r\n  display: inline-block;\r\n  flex: 0 0 auto;\r\n  vertical-align: middle;\r\n}\r\n\r\n.social-pane__edit-button-label svg path,\r\n.social-pane__edit-button-icon svg path,\r\n.social-pane__edit-button .profile-section-collapsible__edit-icon svg path {\r\n  fill: var(--color-primary, #7C4DFF);\r\n  stroke: none;\r\n}\r\n\r\n.social-pane__dialog-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  padding: 1rem;\r\n  background: rgb(15 23 42 / 0.45);\r\n}\r\n\r\n.social-pane__dialog {\r\n  position: relative;\r\n  width: min(32rem, 100%);\r\n  max-height: calc(100vh - 2rem);\r\n  overflow: auto;\r\n  border-radius: 1rem;\r\n  background: var(--white, #fff);\r\n  color: var(--color-text, #111827);\r\n  padding: var(--spacing-md, 1.25rem);\r\n  box-shadow: 0 20px 45px rgb(15 23 42 / 0.25);\r\n}\r\n\r\n.social-pane__dialog-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--spacing-md, 1rem);\r\n  padding-bottom: var(--spacing-base, 0.5rem);\r\n  margin-bottom: var(--spacing-sm, 0.938rem);\r\n  border-bottom: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);\r\n}\r\n\r\n.social-pane__dialog-title {\r\n  margin: 0 0 var(--spacing-base, 0.5rem);\r\n}\r\n\r\n.social-pane__dialog-close {\r\n  flex: 0 0 auto;\r\n  --button-background: transparent;\r\n  --button-border: transparent;\r\n  --button-border-width: 0;\r\n  --button-hover-background: transparent;\r\n  --button-hover-border: transparent;\r\n  color: var(--color-text-subheading, #6b7280);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__dialog-close:hover {\r\n  color: var(--color-text-primary, #364153);\r\n}\r\n\r\n.social-pane__dialog-close:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid var(--color-text-primary, #364153);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__dialog-close svg {\r\n  width: var(--icon-xxxs, 0.75rem);\r\n  height: var(--icon-xxxs, 0.75rem);\r\n}\r\n\r\n.social-pane__dialog-close svg path {\r\n  fill: currentColor;\r\n}\r\n\r\n.social-pane__dialog-form {\r\n  gap: var(--spacing-sm, 0.938rem);\r\n}\r\n\r\n.social-pane__dialog-fields {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-sm, 0.938rem);\r\n}\r\n\r\n.social-pane__dialog-field {\r\n  gap: 0.2rem;\r\n}\r\n\r\n.social-pane__dialog-field-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n}\r\n\r\n.social-pane__dialog-row-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.social-pane__dialog-row {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n}\r\n\r\n.social-pane__dialog-label {\r\n  margin: 0;\r\n  color: var(--gray-700, #364153);\r\n  font-size: var(--font-size-md, 1rem); /* 16px */\r\n  font-weight: var(--font-weight-md, 500);\r\n  line-height: normal;\r\n}\r\n\r\n.social-pane__dialog-input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  min-height: auto;\r\n  resize: none;\r\n}\r\n\r\n.social-pane__dialog-error {\r\n  min-height: 1.25rem;\r\n  margin: 0;\r\n  color: var(--color-warning, red);\r\n}\r\n\r\n.social-pane__dialog-saving-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  background: rgba(255, 255, 255, 0.78);\r\n  z-index: 10;\r\n}\r\n\r\n.social-pane__dialog-saving-overlay[hidden] {\r\n  display: none;\r\n}\r\n\r\n.social-pane__dialog.modal--saving .social-pane__dialog-form {\r\n  opacity: 0.45;\r\n  pointer-events: none;\r\n}\r\n\r\n.social-pane__dialog .modal__saving-indicator {\r\n  gap: 0;\r\n}\r\n\r\n.social-pane__dialog-row-button-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 0;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.social-pane__dialog-row-button-icon svg {\r\n  display: block;\r\n}\r\n\r\n.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add {\r\n  justify-self: flex-start;\r\n  width: auto;\r\n  min-width: 0;\r\n  max-width: none;\r\n  margin-left: auto;\r\n  flex: 0 0 auto;\r\n  box-sizing: border-box;\r\n  --button-min-height: auto;\r\n  --button-padding-sm: var(--spacing-xxs, 0.3125rem);\r\n  --button-background: transparent;\r\n  --button-border: transparent;\r\n  --button-border-width: 0;\r\n  --button-hover-background: transparent;\r\n  --button-hover-border: transparent;\r\n  --button-text: var(--color-primary, #7C4DFF);\r\n  --button-hover-text: var(--color-primary, #7C4DFF);\r\n  --button-height-sm: auto;\r\n  --button-font-weight: var(--font-weight-md, 500);\r\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\r\n  --button-line-height: var(--line-height-base, 1.5);\r\n}\r\n\r\n.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {\r\n  min-height: auto;\r\n  padding: var(--spacing-xxs, 0.3125rem);\r\n  border: none;\r\n  background: none;\r\n  color: var(--color-primary, #7C4DFF);\r\n  font-weight: var(--font-weight-md, 500);\r\n}\r\n\r\n.social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add:hover::part(button) {\r\n  text-decoration: underline;\r\n}\r\n\r\n.social-pane__add-more-content {\r\n  display: inline;\r\n}\r\n\r\n.social-pane__add-more-inline {\r\n  display: inline;\r\n  white-space: normal;\r\n}\r\n\r\n.social-pane__add-more-icon {\r\n  display: inline-block;\r\n  width: var(--icon-xxxs, 0.75rem);\r\n  height: var(--icon-xxxs, 0.75rem);\r\n  margin-right: var(--spacing-xxs, 0.3125rem);\r\n  line-height: 0;\r\n  vertical-align: text-top;\r\n}\r\n\r\n.social-pane__add-more-icon svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n}\r\n\r\n.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove {\r\n  min-height: var(--min-touch-target, 44px);\r\n  min-width: var(--min-touch-target, 44px);\r\n  color: var(--gray-300, #D1D5DC);\r\n  --button-background: transparent;\r\n  --button-box-shadow: none;\r\n  --button-active-box-shadow: none;\r\n  --button-active-transform: none;\r\n  --button-border: transparent;\r\n  --button-border-width: 0;\r\n  --button-border-radius: var(--border-radius-base, 0.3125rem);\r\n  --button-hover-background: var(--lavender-300, #e6dcff);\r\n  --button-hover-border: transparent;\r\n  --button-hover-text: var(--color-primary, #7C4DFF);\r\n  --button-hover-box-shadow: none;\r\n  --button-text: currentColor;\r\n  --button-height-md: var(--min-touch-target, 44px);\r\n  --button-padding-md: 0;\r\n  --button-padding-x-sm: 0;\r\n  --button-icon-size-md: var(--icon-xxs, 1rem);\r\n  --button-icon-size-lg: var(--icon-xxs, 1rem);\r\n}\r\n\r\n.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove:hover,\r\n.social-pane__dialog-row-list solid-ui-button.social-pane__dialog-row-button--remove:focus-within {\r\n  color: var(--gray-300, #D1D5DC);\r\n}\r\n\r\n.social-pane__dialog-row-button-icon--remove svg {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.social-pane__dialog-row-button-icon--remove svg path {\r\n  stroke: currentColor;\r\n}\r\n\r\n.social-pane__dialog-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  padding-top: var(--spacing-base, 0.5rem);\r\n  margin-top: 0;\r\n  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);\r\n}\r\n\r\n.social-pane__dialog-actions > solid-ui-button {\r\n  width: 10.8rem;\r\n}\r\n\r\n.social-pane__dialog-actions > solid-ui-button {\r\n  --button-border-width: 1px;\r\n  --button-border-radius: var(--border-radius-base, 0.3125rem);\r\n  --button-box-shadow: none;\r\n  --button-hover-box-shadow: none;\r\n  --button-active-box-shadow: none;\r\n  --button-active-transform: none;\r\n}\r\n\r\n.social-pane__dialog-actions solid-ui-button.social-pane__dialog-button--save {\r\n  --button-font-size-md: var(--font-size-lg, 1.125rem);\r\n  --button-background: var(--color-primary, #7C4DFF);\r\n  --button-border: var(--color-primary, #7C4DFF);\r\n  --button-text: var(--white, #FFF);\r\n  --button-hover-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 90%, black);\r\n  --button-hover-border: color-mix(in srgb, var(--color-primary, #7C4DFF) 90%, black);\r\n  --button-hover-text: var(--white, #FFF);\r\n}\r\n\r\n.social-pane__dialog-actions solid-ui-button.social-pane__dialog-button--cancel {\r\n  --button-background: var(--white, #FFF);\r\n  --button-border: var(--gray-300, #D1D5DC);\r\n  --button-font-weight: var(--font-weight-normal, normal);\r\n  --button-text: var(--gray-800, #1E2939);\r\n  --button-hover-background: var(--blue-900, #083575);\r\n  --button-hover-border: var(--blue-900, #083575);\r\n  --button-hover-text: var(--white, #FFF);\r\n  --button-font-size-md: var(--font-size-sm, 0.875rem);\r\n}\r\n\r\n.social-pane__header-name {\r\n  color: var(--color-text-heading, #000);\r\n  font-size: var(--font-size-xxl, 1.75rem); /* 28px */\r\n  font-weight: var(--font-weight-bold, 600);\r\n  margin: 0;\r\n  padding: 0;\r\n  text-indent: 0;\r\n  line-height: 1.2;\r\n  text-align: left;\r\n  overflow-wrap: anywhere;\r\n  transform: translateX(-4px);\r\n}\r\n\r\n.social-pane__header-location {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--spacing-2xs, 0.625rem);\r\n  color: var(--color-text-secondary, #4A5565);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  font-weight: var(--font-weight-normal, 400);\r\n  line-height: 1.2;\r\n}\r\n\r\n.social-pane__header-job-org {\r\n  margin: 0;\r\n  color: var(--color-text-subheading, #101828);\r\n  width: 100%;\r\n  white-space: normal;\r\n  font-size: var(--font-size-lg, 1.125rem);\r\n  font-weight: var(--font-weight-md, 500);\r\n  line-height: 1.25;\r\n  text-align: left;\r\n}\r\n\r\n.social-pane__header-location-icon {\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__header-location-icon svg {\r\n  width: var(--icon-xxs, 1rem);\r\n  height: var(--icon-xxs, 1rem);\r\n}\r\n\r\n.social-profile-links {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, max-content);\r\n  align-items: start;\r\n  column-gap: 1rem;\r\n  row-gap: 0.15rem;\r\n}\r\n\r\n.social-pane__header-hero {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;\r\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);\r\n  background: var(--gray-200, #E5E7EB) 50% / cover no-repeat;\r\n  background-position: 50%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n.social-pane__header-hero-icon {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: var(--border-radius-full, 0.625rem) !important;\r\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);\r\n  background: var(--color-card-bg);\r\n  line-height: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.social-pane__header-hero-icon svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.social-pane .social-layout {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.social-pane .social-primary {\r\n  flex: 1 1 70%;\r\n  min-width: 0;\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr);\r\n  grid-template-rows: auto minmax(0, auto);\r\n  gap: 0;\r\n  align-items: start;\r\n}\r\n\r\n.social-pane .social-primary__tabs {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-base, 0.5rem);\r\n  padding: 0;\r\n  background: transparent;\r\n  width: fit-content;\r\n  max-width: 100%;\r\n  margin-bottom: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.social-pane .social-primary__tab {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  border: 0;\r\n  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;\r\n  border-radius: 0;\r\n  background: transparent;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-weight: var(--font-weight-bold, 600);\r\n  padding: var(--spacing-2xs, 0.625rem) 1rem;\r\n  box-shadow: none !important;\r\n  transition: background-color 120ms ease, color 120ms ease, box-shadow 120ms ease;\r\n}\r\n\r\n.social-pane .social-primary__tab:hover {\r\n  background: var(--lavender-300, #e6dcff) !important;\r\n  color: var(--grey-purple-900, #332746);\r\n  box-shadow: none !important;\r\n}\r\n\r\n.social-pane .social-primary__tab[aria-selected='true'],\r\n.social-pane .social-primary__tab--active {\r\n  background: transparent;\r\n  color: var(--grey-purple-900, #332746);\r\n  box-shadow: none !important;\r\n  border-bottom-color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane .social-primary__tab:focus-visible {\r\n  outline: none;\r\n  outline-offset: 2px;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.social-pane .social-primary__panel {\r\n  grid-column: 1;\r\n  grid-row: 2;\r\n  display: none;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n  transform: translateY(0.35rem);\r\n  transition: opacity 160ms ease, transform 160ms ease, visibility 0s linear 160ms;\r\n}\r\n\r\n.social-pane .social-primary__panel--active {\r\n  display: block;\r\n  opacity: 1;\r\n  visibility: visible;\r\n  pointer-events: auto;\r\n  transform: translateY(0);\r\n  border: 0;\r\n  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;\r\n  transition: opacity 180ms ease, transform 180ms ease;\r\n}\r\n\r\n.social-pane .social-pane__mutual-friends,\r\n.social-pane .social-pane__all-friends {\r\n  margin-top: 0;\r\n  padding-top: var(--spacing-xxxs, 0.2rem);\r\n}\r\n\r\n.social-pane .social-main {\r\n  display: table;\r\n  background-color: var(--color-card-bg, #fff);\r\n  color: var(--color-text-primary, #364153);\r\n  border: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.social-pane .social-main--mutual {\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  margin-top: 1em;\r\n  margin-bottom: 1em;\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius-lg, 0.75rem);\r\n}\r\n\r\n.social-pane .social-main--requests {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-md, 1rem);\r\n  margin-top: 0.75rem;\r\n  margin-bottom: 1rem;\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius-lg, 0.75rem);\r\n}\r\n\r\n.social-requests__note {\r\n  margin: 0;\r\n  color: var(--color-text-subheading, #475467);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.5;\r\n}\r\n\r\n.social-requests__group {\r\n  gap: var(--spacing-sm, 0.938rem);\r\n}\r\n\r\n.social-requests__group-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.125rem;\r\n}\r\n\r\n.social-requests__group-title {\r\n  margin: 0;\r\n  color: var(--color-text-heading, #101828);\r\n  font-size: var(--font-size-lg, 1.125rem);\r\n  line-height: 1.25;\r\n}\r\n\r\n.social-requests__group-description,\r\n.social-requests__empty {\r\n  margin: 0;\r\n  color: var(--color-text-subheading, #667085);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.5;\r\n}\r\n\r\n.social-requests__table {\r\n  margin-top: 0;\r\n}\r\n\r\n.social-pane .social-mutual-summary {\r\n  gap: var(--spacing-base, 0.5rem);\r\n}\r\n\r\n.social-pane .social-mutual-summary-line {\r\n  color: var(--slate-700, #314158);\r\n  font-size: var(--font-size-sm, 0.95rem);\r\n  line-height: var(--line-height-base, 1.5);\r\n  justify-content: flex-start;\r\n  padding: 1rem;\r\n}\r\n\r\n.social-pane .social-mutual-summary-line--action {\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-xxs, 0.75rem);\r\n}\r\n\r\n.social-pane .social-mutual-confirm-prompt {\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: var(--spacing-xxxs, 0.2rem);\r\n  font-weight: var(--font-weight-semibold, 600);\r\n}\r\n\r\n.social-pane .social-pane__friend-action--inline {\r\n  position: static;\r\n  top: auto;\r\n  right: auto;\r\n  z-index: auto;\r\n  align-self: flex-start;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form {\r\n  display: block;\r\n  margin: 0;\r\n  padding: 0 1rem 1rem;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-2xs, 0.65rem);\r\n  color: var(--slate-700, #374151);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.4;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form input[type='checkbox'] {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin: 0;\r\n  accent-color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form input[type='checkbox']:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.social-pane .social-friends-list {\r\n  width: 100%;\r\n  margin-top: 0;\r\n}\r\n\r\n.social-pane .social-friends-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n}\r\n\r\n.social-pane .social-friends-grid > tbody {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n}\r\n\r\n.social-pane .social-friends-grid > tr,\r\n.social-pane .social-friends-grid > tbody > tr {\r\n  display: inline-table;\r\n  width: calc(50% - 0.375rem);\r\n  table-layout: fixed;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr,\r\n.social-pane .social-friends-grid > tbody > tr,\r\n.social-pane .social-friend-card {\r\n  border: 1px solid var(--gray-200, #E5E7EB);\r\n  background: var(--white, #fff);\r\n  border-radius: var(--border-radius-lg, 0.75rem);\r\n  overflow: visible;\r\n  box-shadow: 0 1px 3px rgb(0 0 0 / 0.08);\r\n  transition: box-shadow 140ms ease, border-color 140ms ease, transform 140ms ease;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr:hover,\r\n.social-pane .social-friends-grid > tbody > tr:hover,\r\n.social-pane .social-friend-card:hover {\r\n  border-color: var(--gray-300, #D1D5DC);\r\n  box-shadow: 0 6px 18px rgb(0 0 0 / 0.1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.social-pane .social-friends-grid > tr td,\r\n.social-pane .social-friends-grid > tbody > tr td,\r\n.social-pane .social-friend-card td {\r\n  background: var(--color-background, #F8F9FB);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr > td:nth-child(2),\r\n.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) {\r\n  width: auto;\r\n  min-width: 0;\r\n  padding-left: 1.4rem;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr > td:nth-child(3),\r\n.social-pane .social-friends-grid > tbody > tr > td:nth-child(3) {\r\n  width: 2.5rem;\r\n  min-width: 2.5rem;\r\n  padding-left: 0.25rem;\r\n  vertical-align: top;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr > td:first-child,\r\n.social-pane .social-friends-grid > tbody > tr > td:first-child {\r\n  padding-right: 1.2rem;\r\n}\r\n\r\n.social-pane .social-friends-grid td > div > div {\r\n  min-width: 0 !important;\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  white-space: normal !important;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.social-pane .social-friends-grid td > div > div button {\r\n  white-space: normal !important;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child,\r\n.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) > div:first-child {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  gap: 0.2rem 0.4rem;\r\n  min-width: 0;\r\n}\r\n\r\n/* change the style of the name / label in the friend card */\r\n.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child > span:first-of-type,\r\n.social-pane .social-friends-grid > tbody > tr > td:nth-child(2) > div:first-child > span:first-of-type {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  vertical-align: text-top;\r\n  font-size: var(--font-size-lg, 1.125rem); /* 18px */\r\n  font-weight: var(--font-weight-bold, 600); /* new design uses 600 */\r\n  line-height: var(--line-height-tight);\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  overflow: visible;\r\n  text-overflow: clip;\r\n  white-space: normal;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.social-pane .social-friend-pronouns {\r\n  display: inline;\r\n  margin-left: var(--spacing-xs, 0.25rem);\r\n  color: var(--color-text-secondary, #4A5565);\r\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\r\n  font-weight: var(--font-weight-regular, 400);\r\n  line-height: 1.2;\r\n  text-align: left;\r\n}\r\n\r\n.social-pane .social-friend-job-org {\r\n  margin: 0;\r\n  width: 100%;\r\n  min-width: 0;\r\n  white-space: normal;\r\n  overflow-wrap: anywhere;\r\n  color: var(--color-text-subheading, #101828);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  font-weight: var(--font-weight-medium, 500);\r\n  line-height: 1.25;\r\n  text-align: left;\r\n}\r\n\r\n.social-pane .social-friend-location {\r\n  color: var(--color-text-secondary, #6b7280);\r\n  font-size: var(--font-size-xs, 0.8125rem);\r\n  line-height: 1.3;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .social-pane .social-friends-grid > tr,\r\n  .social-pane .social-friends-grid > tbody > tr {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.social-pane .social-friends-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 var(--spacing-xs, 0.75rem) var(--spacing-base, 0.5rem);\r\n  background-color: var(--gray-100, #F3F4F6);\r\n  caption-side: top;\r\n  margin-top: 0;\r\n}\r\n\r\n.social-pane .social-friends-header-title {\r\n  font-size: var(--font-size-md, 1rem);\r\n  font-weight: var(--font-weight-bold, 600);\r\n  color: var(--color-text-primary, #364153);\r\n}\r\n\r\n.social-pane .social-friends-header-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.social-pane .social-friends-header-actions--standalone {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  justify-content: flex-start;\r\n  padding: 0.7rem 1rem 0;\r\n}\r\n\r\n.social-pane .social-friends-header-dropzone {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.social-pane .social-friends-header-dropzone-cell {\r\n  padding: 0;\r\n}\r\n\r\n.social-pane .social-friends-header-hint {\r\n  color: var(--color-text-secondary, #4A5565);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.4;\r\n}\r\n\r\n.social-pane .social-friends-header-actions button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem !important;\r\n  min-width: 2rem !important;\r\n  height: 2rem !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n  border-width: 0 !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.social-pane .social-friends-header-actions button img {\r\n  display: block;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  object-fit: contain;\r\n  pointer-events: none;\r\n}\r\n\r\n/* From tabbedtab.css */\r\n/* ***************** Social Pane **********/\r\n\r\ndiv.social-pane {\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  margin: 0;\r\n}\r\n\r\n.social-pane a {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:hover {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: underline;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:active {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n}\r\n\r\n.social-pane__link-button {\r\n  width: fit-content;\r\n  max-width: 100%;\r\n  display: inline-flex;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: none;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  padding: var(--spacing-xxxs, 0.2rem) var(--spacing-base, 0.5rem);\r\n  text-align: left;\r\n}\r\n\r\n.social-pane__link-button > a {\r\n  display: inline-flex;\r\n  max-width: 100%;\r\n  white-space: normal;\r\n  overflow-wrap: anywhere;\r\n  background-color: transparent;\r\n  color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane__link-button > a:link,\r\n.social-pane__link-button > a:visited,\r\n.social-pane__link-button > a:hover {\r\n  color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane__link-button > a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-content {\r\n  display: grid;\r\n  grid-template-columns: 4.375rem minmax(0, 1fr) auto;\r\n  align-items: start;\r\n  column-gap: var(--spacing-md, 1rem);\r\n  row-gap: 0.25rem;\r\n  padding: 1rem 1rem 0;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-media {\r\n  display: contents;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-details {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.125rem;\r\n  min-width: 0;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-actions {\r\n  grid-column: 3;\r\n  grid-row: 1;\r\n  justify-self: end;\r\n  justify-content: flex-end;\r\n  width: auto;\r\n  gap: var(--spacing-2xs, 0.3125rem);\r\n  margin-left: 0;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-actions--friend {\r\n  grid-column: 1 / -1;\r\n  grid-row: 3;\r\n  justify-self: stretch;\r\n  justify-content: center;\r\n  width: 100%;\r\n  margin-left: 0;\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-summary {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n  width: 100%;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-name, .social-pane__header-job-org, .social-pane__header-location) {\r\n  width: 100%;\r\n  text-align: left;\r\n  justify-content: flex-start;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-stats {\r\n  width: 100%;\r\n  justify-content: flex-start;\r\n  align-self: flex-start;\r\n  gap: var(--spacing-xs, 0.5rem);\r\n  margin-top: -0.4375rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-profile-links {\r\n  grid-column: 1 / -1;\r\n  grid-row: 2;\r\n  grid-template-columns: 1fr;\r\n  row-gap: var(--spacing-xxxs, 0.2rem);\r\n  justify-items: start;\r\n  padding-left: 0;\r\n  margin-top: -0.375rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-primary__tabs,\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-primary__tabs {\r\n  margin-top: -0.5rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__link-button {\r\n  justify-self: start;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__link-button > a {\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  text-align: left;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-field-header {\r\n  grid-template-columns: minmax(0, 1fr);\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-hero, .social-pane__header-hero-icon) {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  width: 5rem;\r\n  height: 5rem;\r\n  aspect-ratio: 1 / 1;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-name {\r\n  font-size: var(--font-size-xl, 1.375rem);\r\n  line-height: 1.15;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__header-job-org {\r\n  font-size: var(--font-size-md, 1rem);\r\n  line-height: 1.25;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friend-pronouns {\r\n  font-size: 0.6875rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__header-location, .social-pane__header-stat),\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friend-location {\r\n  font-size: var(--font-size-xxs, 0.75rem);\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-label, .social-pane__edit-button .profile-section-collapsible__edit-label) {\r\n  display: none !important;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__edit-button {\r\n  --button-background: transparent;\r\n  --button-border-width: 0;\r\n  --button-border: transparent;\r\n  --button-text: var(--color-text, #1A1A1A);\r\n  --button-hover-background: var(--lavender-300, #e6dcff);\r\n  --button-hover-border: transparent;\r\n  --button-hover-text: var(--color-text, #1A1A1A);\r\n  --button-font-size-sm: clamp(0.9rem, 2.1vw, 1rem);\r\n  --button-font-weight: var(--font-weight-regular, 400);\r\n  --button-icon-size-sm: 0.875rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon, .social-pane__edit-button .profile-section-collapsible__edit-icon) {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 0.875rem;\r\n  height: 0.875rem;\r\n  line-height: 0;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon svg, .social-pane__edit-button .profile-section-collapsible__edit-icon svg) {\r\n  width: 0.875rem;\r\n  height: 0.875rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane__edit-button-icon svg path, .social-pane__edit-button .profile-section-collapsible__edit-icon svg path) {\r\n  fill: var(--color-text, #1A1A1A);\r\n  stroke: none;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-actions {\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--spacing-sm, 0.938rem);\r\n  padding: var(--spacing-md, 1rem) 0 0;\r\n  margin: var(--spacing-md, 1rem) auto 0;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-actions > solid-ui-button {\r\n  flex: 0 0 auto;\r\n  width: 10.8rem;\r\n  min-width: 8.5rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: var(--line-height-base, 1.5);\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friends-header-actions--standalone {\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-2xs, 0.625rem);\r\n  padding-top: 0.35rem;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] :is(.social-pane .social-layout, .social-pane .social-primary, .social-layout, .social-primary) {\r\n  display: block;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-pane .social-friends-grid,\r\n:is(.social-pane-host, .social-pane)[data-layout='mobile'] .social-friends-grid {\r\n  display: block;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-input-mode='touch'] {\r\n  --profile-interactive-cursor: auto;\r\n}\r\n\r\n:is(.social-pane-host, .social-pane)[data-input-mode='pointer'] {\r\n  --profile-interactive-cursor: pointer;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .social-pane__header-content {\r\n    display: grid;\r\n    grid-template-columns: 4.375rem minmax(0, 1fr) auto;\r\n    align-items: start;\r\n    column-gap: var(--spacing-md, 1rem);\r\n    row-gap: 0.25rem;\r\n    padding: 1rem 1rem 0;\r\n  }\r\n\r\n  .social-pane__header-media {\r\n    display: contents;\r\n  }\r\n\r\n  .social-pane__header-details {\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.125rem;\r\n    min-width: 0;\r\n  }\r\n\r\n  .social-pane__header-actions {\r\n    grid-column: 3;\r\n    grid-row: 1;\r\n    justify-self: end;\r\n    justify-content: flex-end;\r\n    width: auto;\r\n    gap: var(--spacing-2xs, 0.3125rem);\r\n    margin-left: 0;\r\n  }\r\n\r\n  .social-pane__header-actions--friend {\r\n    grid-column: 1 / -1;\r\n    grid-row: 3;\r\n    justify-self: stretch;\r\n    justify-content: center;\r\n    width: 100%;\r\n    margin-left: 0;\r\n    margin-top: 0.125rem;\r\n  }\r\n\r\n  .social-pane__header-summary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .social-pane__header-name,\r\n  .social-pane__header-job-org,\r\n  .social-pane__header-location {\r\n    width: 100%;\r\n    text-align: left;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .social-pane__header-stats {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    align-self: flex-start;\r\n    gap: var(--spacing-xs, 0.5rem);\r\n    margin-top: -0.4375rem;\r\n  }\r\n\r\n  .social-profile-links {\r\n    grid-column: 1 / -1;\r\n    grid-row: 2;\r\n    grid-template-columns: 1fr;\r\n    row-gap: var(--spacing-xxxs, 0.2rem);\r\n    justify-items: start;\r\n    padding-left: 0;\r\n    margin-top: -0.375rem;\r\n  }\r\n\r\n  .social-pane .social-primary__tabs {\r\n    margin-top: -0.5rem;\r\n  }\r\n\r\n  .social-pane__link-button {\r\n    justify-self: start;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .social-pane__link-button > a {\r\n    font-size: var(--font-size-sm, 0.875rem);\r\n    text-align: left;\r\n  }\r\n\r\n  .social-pane__dialog-field-header {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .social-pane__header-hero,\r\n  .social-pane__header-hero-icon {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    width: 5rem;\r\n    height: 5rem;\r\n    aspect-ratio: 1 / 1;\r\n  }\r\n\r\n  .social-pane__header-name {\r\n    font-size: var(--font-size-xl, 1.375rem);\r\n    line-height: 1.15;\r\n  }\r\n\r\n  .social-pane__header-job-org {\r\n    font-size: var(--font-size-md, 1rem);\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .social-pane .social-friend-pronouns {\r\n    font-size: 0.6875rem;\r\n  }\r\n\r\n  .social-pane__header-location,\r\n  .social-pane__header-stat,\r\n  .social-pane .social-friend-location {\r\n    font-size: var(--font-size-xxs, 0.75rem);\r\n  }\r\n\r\n  .social-pane__friend-action {\r\n    --button-padding-sm: var(--spacing-xxxs, 0.2rem) var(--spacing-xxs-old, 0.3rem);\r\n    --button-font-size-sm: var(--font-size-xs, 0.813rem);\r\n    --button-border-radius-sm: var(--border-radius-base, 0.3125rem);\r\n  }\r\n\r\n  .social-pane__edit-button-label,\r\n  .social-pane__edit-button .profile-section-collapsible__edit-label {\r\n    display: none !important;\r\n  }\r\n\r\n  .social-pane__edit-button {\r\n    --button-background: transparent;\r\n    --button-border-width: 0;\r\n    --button-border: transparent;\r\n    --button-background: transparent;\r\n    --button-text: var(--color-text, #1A1A1A);\r\n    --button-hover-background: var(--lavender-300, #e6dcff);\r\n    --button-hover-border: transparent;\r\n    --button-hover-text: var(--color-text, #1A1A1A);\r\n    --button-font-size-sm: clamp(0.9rem, 2.1vw, 1rem);\r\n    --button-font-weight: var(--font-weight-regular, 400);\r\n    --button-icon-size-sm: 0.875rem;\r\n  }\r\n\r\n  .social-pane__edit-button-icon,\r\n  .social-pane__edit-button .profile-section-collapsible__edit-icon {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 0.875rem;\r\n    height: 0.875rem;\r\n    line-height: 0;\r\n  }\r\n\r\n  .social-pane__edit-button-icon svg,\r\n  .social-pane__edit-button .profile-section-collapsible__edit-icon svg {\r\n    width: 0.875rem;\r\n    height: 0.875rem;\r\n  }\r\n\r\n  .social-pane__edit-button-icon svg path,\r\n  .social-pane__edit-button .profile-section-collapsible__edit-icon svg path {\r\n    fill: var(--color-text, #1A1A1A);\r\n    stroke: none;\r\n  }\r\n\r\n  .social-pane__dialog-actions {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: var(--spacing-sm, 0.938rem);\r\n    padding: var(--spacing-md, 1rem) 0 0;\r\n    margin: var(--spacing-md, 1rem) auto 0;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n  }\r\n\r\n  .social-pane__dialog-actions > solid-ui-button {\r\n    flex: 0 0 auto;\r\n    width: 10.8rem;\r\n    min-width: 8.5rem;\r\n  }\r\n\r\n  .social-pane__dialog-field-header solid-ui-button.social-pane__dialog-row-button--add::part(button) {\r\n    font-size: var(--font-size-sm, 0.875rem);\r\n    line-height: var(--line-height-base, 1.5);\r\n  }\r\n\r\n  .social-pane .social-friends-header-actions--standalone {\r\n    flex-wrap: wrap;\r\n    gap: var(--spacing-2xs, 0.625rem);\r\n    padding-top: 0.35rem;\r\n  }\r\n\r\n  .social-pane .social-layout,\r\n  .social-pane .social-primary {\r\n    display: block;\r\n  }\r\n\r\n  .social-pane .social-friends-grid {\r\n    display: block;\r\n  }\r\n\r\n  .social-pane .social-friends-grid > tr,\r\n  .social-pane .social-friends-grid > tbody > tr {\r\n    display: table;\r\n    width: 100%;\r\n    margin-bottom: var(--spacing-xs, 0.75rem);\r\n  }\r\n\r\n  .social-pane .social-friends-grid > tr:last-child,\r\n  .social-pane .social-friends-grid > tbody > tr:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .social-pane .social-main {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
